import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

export const getRestaurant = createAsyncThunk(
  'restaurant/getRestaurant',
  async userCode => {
    const response = await fetch('https://api.mobrespos.com/get_image', {
      method: 'POST',
      body: JSON.stringify({
        path: `${userCode}/restaurant.json`
      }),
      headers: {
        Accept: 'application/json',
      },
    });
    const restaurantResponse = await response.json();
    //console.log('restaurantResponse', restaurantResponse);
    return restaurantResponse;
  },
);

export const getRestaurantLogo = createAsyncThunk(
  'restaurant/getRestaurantLogo',
  async userCode => {
    const response = await fetch(`https://1zw31qczi7.execute-api.eu-central-1.amazonaws.com/prod/restaurant_pictures/${userCode}/giris_logo_beyaz`, {
      method: 'GET',
    });
    const logoData = await response.text();
    //console.log('logoData', logoData);
    return logoData;
  },
);

export const restaurantSlice = createSlice({
  name: 'restaurants',
  initialState: {
    restaurant: [],
    logo: null,
    isLoading: false,
    isLogoLoading: false,
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getRestaurant.pending, state => {
        state.isLoading = true;
      })
      .addCase(getRestaurant.fulfilled, (state, action) => {
        state.restaurant = action.payload;
        state.isLoading = false;
      })
      .addCase(getRestaurant.rejected, state => {
        state.isLoading = false;
      })
      .addCase(getRestaurantLogo.pending, state => {
        state.isLogoLoading = true;
      })
      .addCase(getRestaurantLogo.fulfilled, (state, action) => {
        state.logo = action.payload;
        state.isLogoLoading = false;
      })
      .addCase(getRestaurantLogo.rejected, state => {
        state.isLogoLoading = false;
      });
  },
});

export default restaurantSlice.reducer;
